const AWS_S3_RESOURCE_URL = import.meta.env.VITE_AWS_S3_RESOURCE;
const VLE_URL = import.meta.env.VITE_VLE_DOMAIN;

const appSettings = {
  vleDomain: VLE_URL,
  productionMode: !["local", "dev", "development"].includes(import.meta.env.MODE),
  loginUrl: import.meta.env.VITE_LOGIN_URL,
  edupassLogoutUrl: import.meta.env.VITE_EDUPASS_LOGOUT_URL,
  authUrl: import.meta.env.VITE_AUTH_URL,
  userGuideUrl: import.meta.env.VITE_USER_GUIDE_URL,
  termOfUseUrl: import.meta.env.VITE_USER_TERM_OF_USE,
  privacyStatementUrl: import.meta.env.VITE_USER_PRIVACY,
  teacherUserGuideUrl: import.meta.env.VITE_TEACHER_USER_GUIDE_URL,
  teacherUserGuideAdaptiveLearningUrl: import.meta.env
    .VITE_TEACHER_USER_GUIDE_ADAPTIVE_LEARNING_URL,
  studentUserGuideUrl: import.meta.env.VITE_STUDENT_USER_GUIDE_URL,
  insertTranscriptUserGuideUrl: import.meta.env.VITE_INSERT_TRANSCRIPT_USER_GUIDE_URL,
  userGuideLoginTroubleshootUrl: import.meta.env.VITE_LOGIN_GUIDE_URL,
  userGuideCreateClassGroupUrl: import.meta.env.VITE_CREATE_CLASS_GROUP_USER_GUIDE_URL,
  schoolBasedHelplineUrl: import.meta.env.VITE_SCHOOL_BASED_HELPLINE_URL,
  osBrowserRequirementUrl: import.meta.env.VITE_OS_BROWSER_REQUIREMENT_URL,
  acceptedFileGuideLocation: import.meta.env.VITE_SLS_ACCEPTED_FILE_GUIDE_LOCATION,
  accessPlannerUserGuideUrl: import.meta.env.VITE_SLS_ACCESS_PLANNER_USER_GUIDE_URL,
  acceptedFileGuideStudentLocation: import.meta.env.VITE_SLS_ACCEPTED_FILE_GUIDE_LOCATION_STUDENT,
  cgResourceGuildinesLocation: import.meta.env.VITE_SLS_CG_GUIDELINES_FILE_LOCATION,
  googleMeetGuideUrl: import.meta.env.VITE_GOOGLE_MEET_GUIDE,
  annotatedFeedbackAssistantGuideUrl: import.meta.env.VITE_AFA_GUIDE_URL,
  teacherPastAssignmentUserGuideUrl: import.meta.env.VITE_TEACHER_PAST_ASSIGNMENT_USER_GUIDE_URL,
  studentPastAssignmentUserGuideUrl: import.meta.env.VITE_STUDENT_PAST_ASSIGNMENT_USER_GUIDE_URL,
  learningAssistantUserGuideUrl: import.meta.env.VITE_LEARNING_ASSISTANT_GUIDE_URL,
  learningAssistantUpperPrimaryModuleUrl: import.meta.env
    .VITE_LEARNING_ASSISTANT_UPPER_PRIMARY_MODULE,
  learningAssistantSecondaryPreUModuleUrl: import.meta.env
    .VITE_LEARNING_ASSISTANT_SECONDARY_PRE_U_MODULE,
  reportVulnerabilityUrl: import.meta.env.VITE_REPORT_VULNERABILITY_URL,
  addConditionUserGuideUrl: import.meta.env.VITE_SLS_GAMIFICATION_ADD_CONDITION_URL,
  gamificationUserGuideUrl: import.meta.env.VITE_SLS_GAMIFICATION_GUIDE_URL,
  printToScanUserGuideUrl: import.meta.env.VITE_SLS_PRINT_TO_SCAN_URL,
  copyrightResourcesUrl: import.meta.env.VITE_SLS_COPYRIGHT_RESOURCES_URL,
  acpHtml5InteractiveGuideUrl: import.meta.env.VITE_SLS_ACP_HTML5_INTERACTIVE_GUIDE_URL,
  learningExperienceDetailUrl: import.meta.env.VITE_SLS_LEARNING_EXPERIENCE_DETAIL_URL,
  contactHelpdeskUrl:
    "https://www.learning.moe.edu.sg/login-troubleshooting/get-help/contact-sls-helpdesk/",
  allowedRedirectDomains: [
    import.meta.env.VITE_VLE_DOMAIN,
    import.meta.env.VITE_USER_GUIDE_URL,
    import.meta.env.VITE_ALS_REPORT_URL,
  ],
  googleAnalyticsTrackingId: import.meta.env.VITE_GOOGLE_ANALYTICS_TRACKING_ID,
  googleAnalyticsMeasurementId: import.meta.env.VITE_GOOGLE_ANALYTICS_MEASUREMENT_ID,
  whitelistedUrlList: import.meta.env.VITE_WHITELISTED_URL_LIST,
  enableLocaleSwitcher: false,
  enableConsole: import.meta.env.VITE_ENABLE_CONSOLE === "true",
  defaultLocale: import.meta.env.VITE_I18N_LOCALE,
  fallbackLocale: import.meta.env.VITE_I18N_FALLBACK_LOCALE,
  supportedLocales: {
    en: "English",
    //if adding support to chinese
    //zh: "中文"
  },
  // REVIEW: add utilities method to construct path to s3 resource
  s3ResourceDomain: AWS_S3_RESOURCE_URL,
  s3AssignmentDomainJSONVersion: import.meta.env.VITE_AWS_S3_ASSIGNMENT_JSON_VERSION,
  s3UgcDomain: import.meta.env.VITE_AWS_S3_UGC,
  s3StaticDomain: import.meta.env.VITE_AWS_S3_STATIC,
  wirisPluginJs: "https://www.wiris.net/demo/plugins/app/WIRISplugins.js?viewer=image",
  algebrakitPluginJs: import.meta.env.VITE_AK_WIDGET_SCRIPT,
  // scripts to be loaded in all pages
  // script to async load, can put async: true
  headerScripts: [
    {
      src: import.meta.env.VITE_WOGAA_SCRIPT_LOCATION,
      async: true,
    },
  ],
  assignmentSettingsPollingInterval: parseInt(
    import.meta.env.VITE_ASSIGNMENT_SETTINGS_POLLING_INTERVAL,
  ),
  topicResponsePollingInterval: parseInt(import.meta.env.VITE_TOPIC_RESPONSE_POLLING_INTERVAL),
  chatResponsePollingInterval: parseInt(import.meta.env.VITE_CHAT_RESPONSE_POLLING_INTERVAL),
  helpdeskEmail: import.meta.env.VITE_HELPDESK_EMAIL,
  helpdeskPhone: import.meta.env.VITE_HELPDESK_PHONE,
  slsInfoSite: import.meta.env.VITE_SLSINFOSITE_URL,

  // Session Management
  userSessionExpiredDuration: parseInt(import.meta.env.VITE_USER_SESSION_TIMEOUT_MILLISECONDS),
  userSessionWarningDuration: parseInt(import.meta.env.VITE_USER_SESSION_TIMEOUT_WARN_MILLISECONDS),
  user2FASessionExpiredDuration: parseInt(import.meta.env.VITE_2FA_SESSION_TIMEOUT_MILLISECONDS),
  user2FASessionWarningDuration: parseInt(
    import.meta.env.VITE_2FA_SESSION_TIMEOUT_WARN_MILLISECONDS,
  ),
  userCSRFSessionExpiredDuration: parseInt(
    import.meta.env.VITE_CSRF_USER_SESSION_TIMEOUT_MILLISECONDS,
  ),
  cryptoEnabled: true,
  otpCountdownInterval: 120,
  otpLength: 6,

  //google integration
  googleAuthClientScope: import.meta.env.VITE_GOOGLE_AUTH_CLIENT_SCOPE,
  googleApiLibraryScript: {
    src: import.meta.env.VITE_GOOGLE_API_LIBRARY_LOCATION,
    async: true,
    defer: true,
  },
  googleAuthLibraryScript: {
    src: import.meta.env.VITE_GOOGLE_AUTH_LIBRARY_LOCATION,
    async: true,
    defer: true,
  },

  // Content Map
  titleCharacterLimit: 250,

  //Template url
  contentMapTemplateLocation: `${VLE_URL}/template/content-map/Content_Map.csv`,
  StudentImportTemplateLocation: `${VLE_URL}/template/school-based-info-import/SampleStudentImportTemplate.csv`,
  TeacherImportTemplateLocation: `${VLE_URL}/template/school-based-info-import/SampleTeacherImportTemplate.csv`,

  // SLS allowed redirect URL
  slsAllowedRedirectUrl: import.meta.env.VITE_SLS_ALLOWED_REDIRECT_URL,

  // AlgebraKit Proxy
  algebraKitProxy: import.meta.env.VITE_AWS_AK_PROXY,

  // Wiris Script / URLs
  wirisAPIRoot: import.meta.env.VITE_WIRIS_API_ROOT,
  wirisEditorScript: import.meta.env.VITE_WIRIS_EDITOR_SCRIPT_LOCATION,

  // API Url
  slsApiEndpoint: import.meta.env.VITE_SLS_API_ENDPOINT,

  // File upload (virus scan) endpoints
  fileScanUrl: import.meta.env.VITE_AWS_S3_FILE_SCAN_PRESIGN_GENERATION_URL,
  fileScanStatusUrl: import.meta.env.VITE_AWS_S3_FILE_SCAN_STATUS_URL,

  // Promise delay interval
  apiPromiseDelayInterval: parseInt(import.meta.env.VITE_API_DELAY_INTERVAL),
  tinymceLicenseKey: import.meta.env.VITE_TINYMCE_LICENSE_KEY,

  // Gogov url
  goGovUrl: import.meta.env.VITE_GO_GOV_URL,

  // User Preference API Base URL
  userApiBaseUrl: import.meta.env.VITE_USER_API_URL,

  // Dictionary API Base URL
  dictionaryApiBaseUrl: import.meta.env.VITE_DICTIONARY_API_URL,

  // HTML5 content host, also the origin of the CloudFront signed-cookie bootstrap endpoint
  s3HtmlDomain: import.meta.env.VITE_AWS_S3_HTML,
};

export default appSettings;
